<template>
  <div class="n-header">
    <!-- 上层 -->
    <div class="n-s">
      <div class="container">
        <h2>欢迎访问京游科技（北京）有限公司~</h2>
        <!-- 登录注册 -->
        <div class="n-login">
          <!-- 注册 -->
          <span @click="goLogin()" v-show="this.LoggedShow" class="login-btn">
            登录
          </span>
          <span @click="goRegister()" v-show="this.LoggedShow" class="register-btn">
           立即注册
          </span>
          <!-- 用户名 -->
          <span
            class="n-info user-info"
            v-show="!this.LoggedShow"
            v-text="this.nv_user.Username"
          >
            <i class="iconfont icon-denglu"></i>
          </span>
          <!-- 退出登录 -->
          <span class="n-info logout-btn" @click="tolg()" v-show="!this.LoggedShow">
            <i class="iconfont icon-tuichudenglu"></i>
            退出登录
          </span>
        </div>
      </div>
    </div>

    <!-- 下层 -->
    <div class="n-x">
      <div class="container">
        <!-- logo -->
        <div class="n-logo">
          <a href="/">
            <div class="logo-content">
              <div class="logo-icon">🚀</div>
              <div class="logo-text">
                <h2>京游科技（北京）有限公司</h2>
                <p>Jingyou Technology (Beijing) Co., Ltd</p>
              </div>
            </div>
          </a>
        </div>
        <!-- 导航 -->
        <div class="n-list">
          <a href="/" class="nav-item">
            <i class="nav-icon">🏠</i>
            <span>网站首页</span>
          </a>
          <a href="/#/ac1" class="nav-item">
            <i class="nav-icon">📰</i>
            <span>行业资讯</span>
          </a>
          <a href="/#/info" class="nav-item">
            <i class="nav-icon">🏢</i>
            <span>公司简介</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 按钮显示/隐藏
      LoggedShow: true,
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.logged();
  },
  methods: {
    // 登录时隐藏逻辑
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },

    // 登录跳转
    goLogin() {
      this.$router.push("/login");
    },
    // 注册跳转
    goRegister() {
      this.$router.push("/register");
    },
    // 退出登录
    tolg() {
      window.localStorage.setItem("state", "10");
      this.LoggedShow = true;
      this.$router.push("/");
      location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";

.n-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: #fff;
  box-shadow: 0 2px 30px rgba(0, 0, 0, 0.08);

  // 上层
  .n-s {
    width: 100%;
    height: 36px;
    background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);

    .container {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      @include flex(space-between);
      padding: 0 20px;

      // 左侧文字
      h2 {
        font-size: 13px;
        color: #b0b0b0;
        font-weight: 400;
        margin: 0;
        letter-spacing: 0.5px;
      }

      // 右侧 登录注册
      .n-login {
        display: flex;
        align-items: center;
        gap: 8px;

        span {
          font-size: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 6px 12px;
          border-radius: 6px;
          font-weight: 500;

          &.login-btn {
            color: #b0b0b0;
            background: rgba(255, 255, 255, 0.05);

            &:hover {
              color: #1890ff;
              background: rgba(24, 144, 255, 0.1);
            }
          }

          &.register-btn {
            color: #fff;
            background: linear-gradient(135deg, #1890ff, #52c41a);
            
            &:hover {
              background: linear-gradient(135deg, #40a9ff, #73d13d);
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
            }
          }

          &.user-info {
            color: #52c41a;
            background: rgba(82, 196, 26, 0.1);
            padding: 6px 16px;
            border-radius: 20px;
            font-weight: 600;
          }

          &.logout-btn {
            color: #ff4d4f;
            background: rgba(255, 77, 79, 0.1);
            
            &:hover {
              background: rgba(255, 77, 79, 0.2);
              color: #ff7875;
            }
          }

          .iconfont {
            font-size: 12px;
          }
        }
      }
    }
  }

  // 下层
  .n-x {
    width: 100%;
    height: 80px;
    background: #fff;

    .container {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      @include flex(space-between);
      padding: 0 20px;

      // logo
      .n-logo {
        a {
          text-decoration: none;
          
          .logo-content {
            display: flex;
            align-items: center;
            gap: 12px;
            
            .logo-icon {
              font-size: 32px;
              background: linear-gradient(135deg, #1890ff, #52c41a);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
            }
            
            .logo-text {
              h2 {
                color: #1a1a1a;
                font-size: 24px;
                font-weight: 700;
                margin: 0;
                line-height: 1.2;
                background: linear-gradient(135deg, #1890ff, #52c41a);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              
              p {
                color: #8c8c8c;
                font-size: 11px;
                margin: 0;
                letter-spacing: 1px;
                font-weight: 500;
              }
            }
          }
        }
      }

      // 导航
      .n-list {
        display: flex;
        align-items: center;
        gap: 8px;
        
        .nav-item {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #595959;
          text-decoration: none;
          padding: 12px 24px;
          border-radius: 10px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-weight: 600;
          font-size: 15px;
          position: relative;
          overflow: hidden;
          
          &::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(24, 144, 255, 0.1), transparent);
            transition: left 0.6s ease;
          }
          
          &:hover {
            background: linear-gradient(135deg, #1890ff, #52c41a);
            color: #fff;
            transform: translateY(-2px);
            box-shadow: 0 8px 25px rgba(24, 144, 255, 0.3);
            
            &::before {
              left: 100%;
            }
            
            .nav-icon {
              transform: scale(1.2);
            }
          }
          
          .nav-icon {
            font-size: 16px;
            transition: transform 0.3s ease;
          }
          
          span {
            position: relative;
            z-index: 1;
          }
        }
      }
    }
  }
}

// 添加导航栏滚动效果
.n-header {
  transition: all 0.3s ease;
}

.n-header.scrolled {
  .n-x {
    height: 70px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  }
}

// 添加入场动画
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.n-header {
  animation: slideDown 0.5s ease forwards;
}

// 响应式调整（虽然不需要移动端，但确保在较大屏幕上表现良好）
@media (min-width: 1400px) {
  .n-s .container,
  .n-x .container {
    width: 1320px;
  }
}
</style>